module.exports = __webpack_public_path__ + "static/media/ic-check-blue.7af12382.svg";